import { render, staticRenderFns } from "./COverviewPageLayout.vue?vue&type=template&id=1b0f8f00&scoped=true&"
import script from "./COverviewPageLayout.vue?vue&type=script&lang=ts&"
export * from "./COverviewPageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./COverviewPageLayout.vue?vue&type=style&index=0&id=1b0f8f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f8f00",
  null
  
)

export default component.exports